@if (isOrderLoading$ | async) {
  <div class="overlay">
    <cx-spinner></cx-spinner>
  </div>
}
@if (order$ | async; as order) {
  <div class="cx-order-summary">
    @if (!(isOrderLoading$ | async)) {
      @if (!(simple$ | async)) {
        <div class="container">
          @if (order.replenishmentOrderCode) {
            <div class="cx-summary-card">
              <cx-card [content]="getReplenishmentCodeCardContent(order?.replenishmentOrderCode) | async"></cx-card>
              <cx-card [content]="getReplenishmentActiveCardContent(order?.active) | async"></cx-card>
            </div>
            @if(!usjfeature){
              <div class="cx-summary-card">
                {{ order?.firstDate | cxDate : dateFormat }}
                <cx-card
                [content]="getReplenishmentStartOnCardContent(order?.firstDate | cxDate : dateFormat) | async"></cx-card>
                <cx-card [content]="getReplenishmentFrequencyCardContent(order?.trigger?.displayTimeTable) | async"></cx-card>
          <cx-card [content]="
                              getReplenishmentNextDateCardContent(order?.trigger?.activationTime | cxDate : dateFormat) | async
                            "></cx-card>
              </div>
            }
            @else {
            <div class="cx-summary-card">
              {{ order?.firstDate | dayjsFormat }}
          <cx-card [content]="
                      getReplenishmentStartOnCardContent(order?.firstDate | dayjsFormat)
                        | async
                    "></cx-card>
              <cx-card [content]="getReplenishmentFrequencyCardContent(order?.trigger?.displayTimeTable) | async"></cx-card>
          <cx-card [content]="
                      getReplenishmentNextDateCardContent(
                        order?.trigger?.activationTime | dayjsFormat
                      ) | async
                     
                    "></cx-card>
            </div>
          }
        } @else {
          <div class="cx-summary-card">
            <cx-card [content]="getOrderCodeCardContent(order?.code) | async"></cx-card>
            @if(!usjfeature){
          <cx-card [content]="
                  getOrderCurrentDateCardContent(order?.created | cxDate: dateFormat) | async
                "></cx-card>
              <cx-card [content]="getOrderStatusCardContent(order.statusDisplay) | async"></cx-card>
            }
            @else {
          <cx-card [content]="
                getOrderCurrentDateCardContent(order?.created | dayjsFormat) | async
                "></cx-card>
          }
          @if ( this.refOrdEnabled) {
            <cx-card [content]="getRefOrder(order?.referenceOrderId) | async"></cx-card>
          }
        </div>
      }
      <div class="cx-summary-card">
        @if(usjfeature){
          <cx-card
            [content]="getOrderStatusCardContent(order.statusDisplay) | async"
          ></cx-card>
        }
        @if (order.paymentType) {
          <cx-card [content]="getPaymentTypeCardContent(order?.paymentType) | async"></cx-card>
          @if ((order.paymentInfo && baseSite != 'b2bportal')) {
            @switch (this.baseSite) {
              @case ('b2bportal_ush') {
                <cx-card [content]="getPaymentInfoCardContent(order?.paymentInfo) | async"></cx-card>
              }
              @case ('b2bportal_lv') {
                <cx-card [content]="getPaymentInfoCardContentUHU(order?.paymentInfo) | async"></cx-card>
              }
              @default {
                <cx-card [content]="getPaymentInfoCardContent(order?.paymentInfo) | async"></cx-card>
              }
            }
            <cx-card [content]="getBillingAddressCardContent(order?.paymentInfo?.billingAddress) | async"></cx-card>
          }
        }
        @if (order.costCenter) {
          <cx-card [content]="getCostCenterCardContent(order?.costCenter) | async"></cx-card>
        }
      </div>
    <!-- </ng-container> -->
    <div class="cx-summary-card">
      @if (order.deliveryAddress) {
        <cx-card [content]="getAddressCardContent(order?.deliveryAddress) | async"></cx-card>
      }
      @if (order.deliveryMode) {
        <cx-card [content]="getDeliveryModeCardContent(order?.deliveryMode) | async"></cx-card>
      }
    </div>
    @if ((order.paymentInfo && baseSite === 'b2bportal' )) {
      <ng-container *cxFeatureLevel="'6.3'">
        @if (order?.paymentInfo?.billingAddress || isPaymentInfoCardFull(order?.paymentInfo)) {
          <div class="cx-summary-card"
            >
            @if (isPaymentInfoCardFull(order?.paymentInfo)) {
              <cx-card [content]="getPaymentInfoCardContent(order?.paymentInfo) | async"></cx-card>
            }
            <cx-card [content]="getBillingAddressCardContent(order?.paymentInfo?.billingAddress) | async"></cx-card>
          </div>
        }
      </ng-container>
      <ng-container *cxFeatureLevel="'!6.3'">
        <div class="cx-summary-card">
          <cx-card [content]="getPaymentInfoCardContent(order?.paymentInfo) | async"></cx-card>
          <cx-card [content]="getBillingAddressCardContent(order?.paymentInfo?.billingAddress) | async"></cx-card>
        </div>
      </ng-container>
    }
  </div>
}
}
</div>
}